import React from "react";
import { cellGrow } from "constants/styles";
import Pill from "components/Pill";
import classnames from "classnames";
import { UI_THEME } from "utils/constants/ui";
import { COLORS } from "utils/styles";
import { gridContainer } from "constants/styles";

const FEATURES = {
  LINKS: "links",
  PAGES: "pages",
  CHECKOUT: "checkout",
  AUTOMATIONS: "automations"
};

const DOCS_GRID_CONFIG = [
  {
    id: FEATURES.LINKS,
    label: "Payment links",
    description:
      "Create payment links built on top of Stripe checkout for any payment scenario."
  },
  {
    id: FEATURES.PAGES,
    label: "Payment pages",
    description:
      "Build and publish Stripe integrated checkout pages using our no code page builder."
  },
  {
    id: FEATURES.CHECKOUT,
    label: "Stripe Checkout",
    description:
      "All payments are securely handled through Stripe's pre-built checkout pages."
  },
  {
    id: FEATURES.AUTOMATIONS,
    label: "Automations",
    description:
      "Connect all of your Stripe Checkout started and completed events to any workflow using our Zapier integration."
  }
];

const FeatureGrid = () => {
  return (
    <div className="w-100">
      <div className="grid-container-2xl pt3">
        {DOCS_GRID_CONFIG.map(
          ({ Icon, label, description, callout, footer }, gridIx) => {
            return (
              <div className="w-100 pb3 pb0-ns" key={gridIx}>
                <div className="flex flex-row justify-between items-center">
                  <div className="flex flex-row items-center w-100">
                    {Icon && <Icon size={20} color={COLORS.primary} />}
                    <div
                      className={classnames(
                        "f4 f3-l fw6 color-text--primary lh-title",
                        {
                          pl2: Icon
                        }
                      )}
                      style={{ marginTop: 2 }}
                    >
                      {label}
                    </div>
                  </div>
                  {callout && <Pill copy={callout} theme={UI_THEME.SLIM} />}
                </div>
                <div className="f5 f4-l lh-copy pt2 mt1 color-text--primary">
                  {description}
                </div>
                {footer}
              </div>
            );
          }
        )}
        <style jsx>{gridContainer}</style>
        <style jsx>{cellGrow}</style>
      </div>
    </div>
  );
};

export default FeatureGrid;
